<ap-sign
    [actionId]="actionId"
    [additionalTokens]="additionalTokens"
    [showWysiwys]="false"
    [allowPendingTokens]="true"
    [submitText]="'klant.login.sign.submit' | apContent"
    [initWithToken]="getInitToken()"
    [showLostCredentials]="true"
    [saveTokenIdKey]="saveTokenIdKey"
    [ariaDescribedByIds]="ariaLabelsForNotifications"
    [browserRegister]="hasBrowserRegister"
    (done)="onComplete()"
    (retry)="onRetry()"
    (updatePassword)="onUpdatePassword($event)"
    (updateUsernamePassword)="onUpdateUsernamePassword($event)"
    (tokenChanged)="onTokenChanged($event)"
    (signError)="onSignError($event)"
    (signedWithPendingToken)="onPendingToken($event)"
    (browserLostCredentials)="onLostBrowserCredentials($event)"
>
</ap-sign>
